export const getCookiesMap = (): Record<string, string> => {
    const cookiesMap: Record<string, string> = {};
    const cookieString = document.cookie;
    if ( !cookieString ) {
        return cookiesMap;
    }

    cookieString.split( ';' ).forEach( (cookie ) => {
        const separatorIndex = cookie.indexOf( '=' );
        if ( separatorIndex == -1 ) {
            return;
        }
        const name = cookie.substring( 0, separatorIndex ).trim();
        if ( !name ) {
            return;
        }
        let value = cookie.substring( separatorIndex + 1 );
        if (value.startsWith('"') && value.endsWith('"')) {
            value = value.slice(1, -1);
        }
        try {
            value = decodeURIComponent( value );
        } catch ( e ) {
            console.warn( `Failed to decode cookie value ${value} for ${name}`, e );
        }

        cookiesMap[name] = value;
    });

    return cookiesMap;
};
